module.exports={
    logout  : " تسجيل الخروج ",
    my      :' ا > ? ',
    scqx    :' حذف الأذونات ',
    qxgl    :' إدارة الحقوق ',
    qdzxzhm :' هل أنت متأكد من تسجيل الخروج ؟ ',
    qtxkh   :' يرجى ملء رقم البطاقة ',
    qd      :' أكّد ',
    qx      :' ألغى ',
    gb      :' غلق ',
    kh      :' رقم البطاقة ',
    kmewm   :' فتح رمز ثنائي الأبعاد ',
    dl      :' سجل ',
    name    :' اسم المستخدم ',
    qtxname :' يرجى ملء اسم المستخدم ',
    pwas    :' كلمة السر ',
    qtxpwas :' يرجى ملء كلمة المرور ',
    tj      :' قدم ',
    zczh    :' رقم التسجيل ',
    zc      :' التسجيل ',
    sjhm    :' رقم الجوال ',
    qtxsjhm :' يرجى ملء رقم الهاتف المحمول ',
    yzm     :' رمز التحقق ',
    qtxyzm  :' يرجى ملء رمز التحقق ',
    yyzhqqdl:' حساب موجود ، انتقل إلى تسجيل الدخول',
    hqyzm   :' الحصول على رمز التحقق ',
    zccg    :' النجاح في التسجيل',
    zcsb    :' فشل التسجيل ',
    fscg    :' إرسال بنجاح',
    fssb    :' فشل إرسال',
    yhycz   :' المستخدم موجود بالفعل',
	// 设备搜索页面
	sbss:' جهاز البحث ',
	kysb:' المعدات المتاحة ',
	ssjg:' نتائج البحث عن ',
	sbtj:' إضافة جهاز ',
	sblx:' نوع الجهاز ',
	sfwzcj:' هو مسجل ',
	qxz:' الرجاء اختيار ',
	azwz:' تركيب الكلمات ',
	kmzt:' فتح الباب في الدولة ',
	wifimm:' واي فاي كلمة السر ',
}